import type { FunctionComponent } from "react";
import FavouritesAdminPartial from "../../../partials/admin/favourites/favourites.admin.partials";

export const FavouritesAdminScreen: FunctionComponent = () => {
	return <FavouritesAdminPartial />;
};
